import Button from 'components/Button';
import { Props } from 'components/Button/types';
import React, { memo } from 'react';

const UserProfileFollowButton = ({
  followed,
  mode = 'default',
  className,
  onClick,
}: {
  followed: boolean;
  mode?: Props['mode'];
  hideIcon?: boolean;
  className?: string;
  onClick: (e: React.MouseEvent) => void;
}) => {
  return (
    <Button
      variant={followed ? 'secondary' : 'primary'}
      className={className}
      mode={mode}
      onClick={onClick}
    >
      {followed ? <>Unfollow</> : <>Follow</>}
    </Button>
  );
};

export default memo(UserProfileFollowButton);
